import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { 
	AUTH_PREFIX_PATH, 
	UNAUTHENTICATED_ENTRY, 
	REDIRECT_URL_KEY 
} from 'configs/AppConfig'

const ProtectedRoute = () => {
	
	const { token, mustChangePassword } = useSelector(state => state.auth)
	const location = useLocation()

	if (!token) {
		return <Navigate to={`${UNAUTHENTICATED_ENTRY}?${REDIRECT_URL_KEY}=${location.pathname}`} replace />;
	}

	// If user must change password, redirect to set-password page
	if (mustChangePassword && location.pathname !== `${AUTH_PREFIX_PATH}/set-password`) {
		return <Navigate to={`${AUTH_PREFIX_PATH}/set-password`} replace />;
	}

	return <Outlet />
}

export default ProtectedRoute
